<div class="container-box p-3">
  <div [class.loading-section]="isSaving$ | async">
    <div class="map-holder">
      <h6 class="text-uppercase" i18n>GPS Location</h6>
      <app-map-control [formControl]="form.get('gps')" [zoom]="14" height="400px"></app-map-control>
    </div>
  </div>
</div>
